import * as React from 'react';
import * as ToggleGroupPrimitive from '@radix-ui/react-toggle-group';

import { cn } from 'src/lib/utils';

const ToggleGroup = React.forwardRef<
  React.ComponentRef<typeof ToggleGroupPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof ToggleGroupPrimitive.Root>
>(({ className, ...props }, ref) => {
  return <ToggleGroupPrimitive.Root className={cn('', className)} {...props} ref={ref} />;
});
ToggleGroup.displayName = ToggleGroupPrimitive.Root.displayName;

const ToggleGroupItem = React.forwardRef<
  React.ComponentRef<typeof ToggleGroupPrimitive.Item>,
  React.ComponentPropsWithoutRef<typeof ToggleGroupPrimitive.Item>
>(({ className, ...props }, ref) => {
  return (
    <ToggleGroupPrimitive.Item
      ref={ref}
      className={cn(
        'text-sm font-medium text-ebony_opacity_80 capitalize focus:outline-none disabled:cursor-not-allowed disabled:opacity-50 [&[data-state=on]]:pointer-events-none border py-2.5 rounded-sm-5 [&[data-state=on]]:border-[#a498ff80] hover:border-[#a498ff80] border-[#E3E6E8] bg-white [&[data-state=on]]:bg-[#a498ff1a]',
        className,
      )}
      {...props}
    />
  );
});
ToggleGroupItem.displayName = ToggleGroupPrimitive.Item.displayName;

export { ToggleGroup, ToggleGroupItem };
